import SearchVehicleFilterState from "@dana/Store/Data/SearchVehicleFilter/SearchVehicleFilterState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { AttributeTypeFacetModel, AttributeValueFacetModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

const initialCounterState: SearchVehicleFilterState = {
    selectedYear: undefined,
    selectedMake: undefined,
    selectedModel: undefined,
    selectedEngine: undefined,
    yearFacet:undefined,
    makeFacet: undefined,
    modelFacet: undefined,
    clearSearch: false,
    isFilterLoading: false
};

const searchVehicleStateImmerReducer = createTypedReducerWithImmer(initialCounterState, {
    "SearchVehicle/Filter/IsLoading": (draft: Draft<SearchVehicleFilterState>, action: { isLoading: boolean }) => {
        draft.isFilterLoading = action.isLoading;
    },
    "SearchVehicle/Filter/PopulateInitialFacet": (draft: Draft<SearchVehicleFilterState>, action: { filterFacet: AttributeTypeFacetModel }) => {
        //  draft.yearFacet = action.yearFacet || null;
    },
    "SearchVehicle/Filter/PopulateResult": (draft: Draft<SearchVehicleFilterState>, action: { selectedYear: AttributeValueFacetModel, selectedMake: AttributeValueFacetModel, selectedModel: AttributeValueFacetModel, selectedEngine: AttributeValueFacetModel, filterFacet: AttributeTypeFacetModel; }) => {

        draft.selectedYear = action.selectedYear;
        draft.selectedMake = action.selectedMake;
        draft.selectedModel = action.selectedModel;
        draft.selectedEngine = action.selectedEngine;
        if (action?.filterFacet?.name === "Year") {
            draft.yearFacet = action.filterFacet;
        }
        if (action?.filterFacet?.name === "Make") {
            draft.makeFacet = action.filterFacet;
        }
        if (action?.filterFacet?.name === "Model") {
            draft.modelFacet = action.filterFacet;
        }
    },
    "SearchVehicle/Filter/UpdateSearchParamater": (draft: Draft<SearchVehicleFilterState>, action: { selectedYear: AttributeValueFacetModel, selectedMake: AttributeValueFacetModel, selectedModel: AttributeValueFacetModel, selectedEngine: AttributeValueFacetModel, }) => {

        draft.selectedYear = action.selectedYear;
        draft.selectedMake = action.selectedMake;
        draft.selectedModel = action.selectedModel;
        draft.selectedEngine = action.selectedEngine;
    },
    "SearchVehicle/Filter/ClearSearch": (draft: Draft<SearchVehicleFilterState>, action: { clearSearch: boolean }) => {
        draft.clearSearch = action.clearSearch;
    },
});

(reducers as any).searchVehicleFilter = searchVehicleStateImmerReducer;

type SearchVehicleReducers = {
    searchVehicleFilter: typeof searchVehicleStateImmerReducer;
};

export type SearchVehicleActions = Parameters<SearchVehicleReducers[keyof SearchVehicleReducers]>[1] | AnyAction;


